import React, { useState } from "react";
import "./GameCreator.scss";
import { DNA, DNAAnswers, DNAElementValue, DNAValue } from "../../../components/Game/DNA/DNA";
import { Answers } from "../../../components/Game/Answers/Answers";
import { Button } from "../../../components/Button/Button";
import { ElementAnswers } from "../../../components/Game/Answers/ElementAnswers/ElementAnswers";

interface IProps {

}

export function GameCreator(props: IProps) {
    const [result, setResult] = useState<DNAValue>([[0,1,1,0],[1,0,0,0],[0,1,0,2]]);
    const [answers, setAnswers] = useState<DNAAnswers>([[[0,0,1,0],[0,1,0,0]],[[1,0,0,0]],[[0,0,0,1],[0,1,0,1]]]);
    const [wrongAnswers, setWrongAnswers] = useState<DNAElementValue[]>([]);

    const handleExport = () => {
        const data = JSON.stringify({result, answers, wrongAnswers});
        const dataStr = "data:text/json;charset=utf-8," + encodeURIComponent(data);
        const dlAnchorElem = document.createElement('a');
        dlAnchorElem.setAttribute("href",     dataStr     );
        dlAnchorElem.setAttribute("download", "game-level.json");
        dlAnchorElem.click();
    }

    return (
        <div className="game-creator-wrapper">
            <h1>Outcome</h1>
            <DNA value={result} setValue={setResult} />

            <h1>Answers</h1>
            <Answers answers={answers} setAnswers={setAnswers} />

            <h1>Wrong answers</h1>
            <div className="answers-wrapper">
                <ElementAnswers answers={wrongAnswers} setAnswers={setWrongAnswers} />
            </div>

            <br /><br />

            <Button onClick={handleExport}>Export to JSON</Button>
        </div>
    )
}
